
import { call, put, select } from 'redux-saga/effects'
import request from '@src/utility/request'
import { 
    loadStepsDataSuccess,
    loadStepsDataFail,
    addStepSuccess,
    addStepFail,
    updateStepSuccess,
    updateStepFail,
    deleteStepSuccess,
    deleteStepFail,
    loadStepsData,
    publishRouteSuccess,
    publishRouteFail,
    requestStepDataFail,
    requestStepDataSuccess,
    updateStepCordsSuccess,
    updateStepCordsFail,
    updateRoutePanZoomFail,
    updateRoutePanZoomSuccess,
    resetPartnerPasswordSuccess,
    resetPartnerPasswordFail,
    deletePartnerRequestFail,
    deletePartnerRequestSuccess
} from '../../actions/steps'
import { 
    selectStepsFetchUrl
} from '../../selectors/steps'
import { selectBaseUrl, selectLocale } from '../../selectors/config'
import { selectToken } from '../../selectors/auth'
import { toast, Slide } from 'react-toastify'
import ToastContent from '../../../components/Toast'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


const MySwal = withReactContent(Swal)

// worker Saga: will be fired on FETCH_STEPS action
export function* fetchSteps(params) {
    const { identifier } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectStepsFetchUrl())
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())
    const callback = params.callback

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)
        
        if (res.data.id) {
            yield put(loadStepsDataSuccess(identifier, res.data))
            if (callback) yield callback()
        } else {
            yield put(loadStepsDataFail(identifier, res.data))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data} />,
                { transition: Slide, hideProgressBar: true }
            )
        }

      
    } catch (e) {
       yield put(loadStepsDataFail(identifier, [{message: e.message}]))
      
       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on DELETE_STEP action
export function* deleteStep(params) {
    const { id, identifier } = params
   
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "processStepDelete"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
     
    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
        
        if (res.data.toString().indexOf('success') > 0) {
            yield put(deleteStepSuccess(id))
            yield put(loadStepsData(identifier))
        } else {
            yield put(deleteStepFail(id, res.data))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={ res.data} />,
                { transition: Slide, hideProgressBar: true }
                )
        } 
        
      
    } catch (e) {
       yield put(deleteStepFail(id, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on ADD_STEP action
export function* addStep(params) {
    const { identifier, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "processStepCreate"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {
       
       
        if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            console.log(k)
            if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
        } 
        else if(data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if(data[k]) formdata.append(k, data[k])
    
    }
    /*eslint-enable */


    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/`, requestOptions)
        
        if (res.data?.id) {
            
            yield put(addStepSuccess(res.data))
            yield put(loadStepsData(res.data.refProductRoute[0].identifier))
        } else yield put(addStepFail(res.data))
        
      
    } catch (e) {
       yield put(addStepFail([{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}


// worker Saga: will be fired on UPDATE_STEP action
export function* updateStep(params) {
    const { id, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "processStepUpdate"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {
       
       
        if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            console.log(k)
            if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
        } 
        else if(data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if( data[k]!== null) formdata.append(k, data[k])
    
    }
    /*eslint-enable */

     
    const requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
        
        if (res.data?.id) {
            yield put(updateStepSuccess(id, res.data))
            if (res.data?.refProductRoute[0]?.identifier) {
              yield put(loadStepsData(res.data.refProductRoute[0].identifier))
            }
        } else yield put(updateStepFail(id, res.data))
        
      
    } catch (e) {
       yield put(updateStepFail(id, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}


// worker Saga: will be fired on UPDATE_STEP_CORDS action
export function* updateStepCords(params) {
  const { id, data } = params
  const requestURL = yield select(selectBaseUrl())
  const locale = yield select(selectLocale())
  const dataURL = "ProcessStepUpdateCords"
  const token = yield select(selectToken())
  
  const myHeaders = { 
      Accept: "application/json",
      "Content-Type":"multipart/form-data",
      "Accept-Language":locale,
      "User-Agent": "AFTS Web App",
      Authorization: `Token ${token}`,
      Origin : "*"
  }

  /*eslint-disable */
  let formdata = new FormData()
  for (let k in data) {
     
     
      if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
          console.log(k)
          if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
      } 
      else if(data[k].length && data[k].map){
          data[k].map((item) => {
              formdata.append(k, item)
          })
      }
      else if( data[k]!== null) formdata.append(k, data[k])
  
  }
  /*eslint-enable */

   
  const requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      data:formdata,
      mode:'cors',
      credentials:'include'
  }

  try {
      
      const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
      
      if (res.data?.id) {
          yield put(updateStepCordsSuccess(id, res.data))
          if (res.data?.refProductRoute[0]?.identifier) {
            yield put(loadStepsData(res.data.refProductRoute[0].identifier))
          }
      } else yield put(updateStepCordsFail(id, res.data))
      
    
  } catch (e) {
     yield put(updateStepCordsFail(id, [{message: e.message}]))

     toast.error(
      <ToastContent type="error" title="Ooops!" body={e.message} />,
      { transition: Slide, hideProgressBar: true }
      )
  }
}

// worker Saga: will be fired on PUBLISH_ROUTE action
export function* publishRoute(params) {
    const { identifier } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "productRoutePublish"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:{},
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)
        
        if (res.data?.IPFS_hash) {
            
            yield put(publishRouteSuccess(identifier))

            MySwal.fire({
                title: 'Hurray!',
                text: 'Route has been published successfully!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else yield put(publishRouteFail(identifier, res.data))
        
      
    } catch (e) {
       yield put(publishRouteFail(identifier, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on REQUEST_STEP_DATA action
export function* requestStepData(params) {
    const { stepId, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "stepDataRequest"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
     let formdata = new FormData()
     for (let k in data) {
        
        
         if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
             console.log(k)
             if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
         } 
         else if(data[k].length && data[k].map){
             data[k].map((item) => {
                 formdata.append(k, item)
             })
         }
         else if( data[k]!== null) formdata.append(k, data[k])
     
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${stepId}`, requestOptions)
        
        if (res.data === "Email was sent sucessfully") {
            
            yield put(requestStepDataSuccess(stepId))

            MySwal.fire({
                title: 'Hurray!',
                text: res.data,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else {
            yield put(requestStepDataFail(stepId, res.data))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data} />,
                { transition: Slide, hideProgressBar: true }
            )
        }
        
      
    } catch (e) {
       yield put(requestStepDataFail(stepId, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on UPDATE_ROUTE_PAN_ZOOM action
export function* updateRoutePanZoom(params) {
  const { identifier, data } = params
  const requestURL = yield select(selectBaseUrl())
  const locale = yield select(selectLocale())
  const dataURL = "updateRoutePanZoom"
  const token = yield select(selectToken())
  
  const myHeaders = { 
      Accept: "application/json",
      "Content-Type":"application/json",
      "Accept-Language":locale,
      "User-Agent": "AFTS Web App",
      Authorization: `Token ${token}`,
      Origin : "*"
  }

  const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      data:{data},
      mode:'cors',
      credentials:'include'
  }

  try {
      const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)
      
      if (res.data) {
        yield put(updateRoutePanZoomSuccess(identifier))
      } else yield put(updateRoutePanZoomFail(identifier, res.data))
    
  } catch (e) {
      yield put(updateRoutePanZoomFail(identifier, [{message: e.message}]))
  }
}

// worker Saga: will be fired on RESET_PARTNER_PASSWORD action
export function* resetPartnerPasswordData(params) {
    const { partnerId, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "partnerResetPassword"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: {},
        mode:'cors',
        credentials:'include'
    }

    try {

        toast.info(
            <ToastContent type="error" title="Password Reset" body={"Request Initiated"} />,
            { transition: Slide, hideProgressBar: true }
        )
        
        const res = yield call(request, `${requestURL}${dataURL}/${partnerId}`, requestOptions)
        
        if (res.data.status === "success") {
            
            yield put(resetPartnerPasswordSuccess(partnerId))

            MySwal.fire({
                title: 'Hurray!',
                text: res.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else {
            yield put(resetPartnerPasswordFail(partnerId, res.data.message))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data.message} />,
                { transition: Slide, hideProgressBar: true }
            )
        }
        
      
    } catch (e) {
       yield put(resetPartnerPasswordFail(partnerId, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on DELETE_PARTNER_REQUEST action
export function* deletePartnerRequestData(params) {
    const { partnerId, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "partnerDeleteRequest"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: {},
        mode:'cors',
        credentials:'include'
    }

    try {

        toast.info(
            <ToastContent type="error" title="Partner Delete Request" body={"Request Initiated"} />,
            { transition: Slide, hideProgressBar: true }
        )
        
        const res = yield call(request, `${requestURL}${dataURL}/${partnerId}`, requestOptions)
        
        if (res.data.status === "success") {
            
            yield put(deletePartnerRequestSuccess(partnerId))

            MySwal.fire({
                title: 'Request Sent!',
                text: res.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else {
            yield put(deletePartnerRequestFail(partnerId, res.data.message))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data.message} />,
                { transition: Slide, hideProgressBar: true }
            )
        }
        
      
    } catch (e) {
       yield put(deletePartnerRequestFail(partnerId, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}